document.addEventListener('alpine:init', () => {
  Alpine.data(
    'Theme_HeroSlideshow',
    ({
      autoplay = false,
      autoplayInterval = null,
      mode = 'slideshow',
      gap = null,
      onlyIfNeeded = false,
    }) => ({
      autoplay,
      autoplayInterval,
      playing: false,
      splide: null,
      rate: 0,
      mode,
      gap,
      onlyIfNeeded,
      maxLgBreakpointMQL: window.matchMedia('(max-width: 1023px)'),
      init() {
        if (typeof Splide === 'undefined') {
          console.error('Splide not available');
          return;
        }

        this.initSplide();

        if (this.onlyIfNeeded) {
          this.destroyOrInitIfNeeded();

          this.maxLgBreakpointMQL.addEventListener('change', () => {
            this.destroyOrInitIfNeeded();
          });
        }

        if (Shopify.designMode) {
          this._setUpDesignModeHandlers();
        }

        document.addEventListener('dev:hotreloadmutation', async () => {
          if (!Shopify.designMode) {
            this.splide.destroy();
            await this.$nextTick();
            this.initSplide();
          }
        });
      },
      initSplide() {
        const options = {
          type: 'slide', // Changed from 'fade' to 'slide' for scroll compatibility
          arrows: true,
          pagination: true,
          rewind: true,
          speed: 1500,
          start: parseInt(this.$root.dataset.start, 10) - 1 || 0,
          interval: this.autoplayInterval,
          autoplay: this.autoplay,
          drag: true,
        };

        if (this.gap) {
          options.gap = this.gap;
        }

        this.splide = new Splide(this.$root, options);

        if (options.autoplay) {
          this.splide.on('autoplay:play', () => {
            this.playing = true;
          });
          this.splide.on('autoplay:pause', () => {
            this.playing = false;
          });
          this.splide.on('autoplay:playing', (rate) => {
            this.rate = rate;
          });
        }

        this.splide.mount();

        this.$nextTick(() => {
          let scrollLocked = false;

          this.$root.addEventListener(
            'wheel',
            (e) => {
              const isMostlyHorizontal = Math.abs(e.deltaX) > Math.abs(e.deltaY);
              if (!isMostlyHorizontal || scrollLocked) return;

              e.preventDefault();
              scrollLocked = true;

              if (e.deltaX > 0) {
                this.splide.go('>');
              } else {
                this.splide.go('<');
              }

              this.splide.on(
                'moved',
                () => {
                  scrollLocked = false;
                },
                { once: true }
              );
            },
            { passive: false }
          );
        });
      },
      destroyOrInitIfNeeded() {
        const slideEls = Array.from(
          this.$root.querySelectorAll('.splide__slide')
        );

        const totalSlidesWidth = slideEls.reduce(
          (totalWidth, slideEl) =>
            totalWidth + slideEl.getBoundingClientRect().width,
          0
        );

        const totalGridlinesWidth =
          parseFloat(
            getComputedStyle(document.documentElement).getPropertyValue(
              '--gridline-width'
            )
          ) *
          (slideEls.length - 1);

        const totalContentWidth = totalSlidesWidth + totalGridlinesWidth;

        if (totalContentWidth <= this.$root.getBoundingClientRect().width) {
          if (splideIsNotDestroyed(this.splide)) this.splide.destroy();
        } else {
          if (!splideIsNotDestroyed(this.splide)) this.initSplide();
        }
      },
      _setUpDesignModeHandlers() {
        this.$root.addEventListener('slideshow-go', (e) => {
          if (!e.detail) return;
          this.splide.go(parseInt(e.detail, 10));
        });
      },
    })
  );
});